module.exports = __webpack_public_path__ + "img/basicauth.9438fe27.svg";